<template>
    <div class="shortmessageindex">
        <div class="top">
            <el-col :span="19">     
               <el-button type="primary" size="medium" @click="Identificationmanagementlist()">充值记录总表</el-button>
               <location-selector  @change="handleFilter()"  v-model="locationArray"></location-selector>
               <a
                    :href="downLoadHref"
                    target="_blank"
                    download="导出"
                >
                    <el-button
                        type="primary"
                        size="medium"
                    >导出
                    </el-button>
                </a>
                <el-button type="primary" size="medium" @click="refreshPeopleCount()">刷新学校人数</el-button>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入学校名称" v-model.trim="listQuery.searchName" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>	
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%" >
             <el-table-column  label="学校名称" show-overflow-tooltip  >
                <template slot-scope="scope">
                    <span class="link-type" @click="Identificationmanagementschool(scope.row.schoolId)"> {{scope.row.schoolName}}</span>                   
                </template>
            </el-table-column>  
             <el-table-column label="学校人数" align="center">
                <template slot-scope="scope">
                        {{scope.row.peopleCount?scope.row.peopleCount:0}}
                </template>
            </el-table-column> 
            <el-table-column label="总额度" align="center">
                <template slot-scope="scope">
                        {{scope.row.totalCount?scope.row.totalCount:0}}
                </template>
            </el-table-column>   
            <el-table-column label="已使用" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.usedCount}}
                </template>
            </el-table-column> 
             <el-table-column label="剩余" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.usableCount}}
                </template>
            </el-table-column> 
             <el-table-column label="预计剩余任务次数" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    <span :class="{'red':Math.floor(scope.row.usableCount/(scope.row.peopleCount*10))<5}">
                         {{Math.floor(scope.row.usableCount/(scope.row.peopleCount*10))}} 次
                    </span>                     
                </template>
            </el-table-column> 
             <el-table-column label="单价" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                       {{scope.row.price/100}}
                </template>
            </el-table-column> 
              <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="dialogVisiblefun(scope.row)"  type="text" size="small">修改单价</el-button>
                         <el-button  @click.native.prevent="rechargeReminds(scope.row.schoolId)"  type="text" size="small">充值提醒</el-button>
                         <el-button  @click.native.prevent="Identificationmanagementadd(scope.row)"  type="text" size="small">充值</el-button>
                    </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
           <el-dialog title="修改单价" :visible.sync="dialogVisible" size="tiny"  width="400px" >
                <div class="input">
                   单价 &nbsp;&nbsp;&nbsp; <el-input-number v-model="myobj.price" :precision="2" :step="0.01" :min="0.01" :max="10" placeholder="请输入单价" ></el-input-number>
                </div>
                <span  slot="footer"  class="dialog-footer"   >
                    <el-button  @click="dialogVisible=false">取 消</el-button>
                    <el-button  type="primary" @click="updateOcrSchools()" >确 定</el-button>
                </span>
             </el-dialog>
    </div>
</template>
<script>
    import {queryOcrSchool,rechargeRemind,updateOcrSchool,initAllOcrSchool,refreshPeopleCount} from '@/api/Identificationmanagement';
    import LocationSelector from '@/components/LocationSelector';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    searchName: '',
                    areaCode:""
                },
                dataList: [],
                total: null,
                locationArray: ['320000', '320100', '0'],  
                dialogVisible:false,
                myobj:{
                    id:"",
                    peopleCount:"",
                    price:""
                },
                downLoadHref: "",
            }
        },
        components: {LocationSelector},
        created() {
            // initAllOcrSchool().then(res => {
                       this.queryFoodLists();
                    // }).catch();
            
        },
        mixins: [mixin],       
        methods: {   
             refreshPeopleCount() {
                this.$confirm('是否确认要刷新学校人数？', '刷新学校人数', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    refreshPeopleCount()
                        .then(res => res.data)
                        .then(data => {
                            if(data.result) {
                                this.$message({
                                    message: '刷新学校人数成功',
                                    type: 'success'
                                });
                                this.queryFoodLists();
                            }
                        })
                });
            },
            dialogVisiblefun(obj){
               this.myobj={
                   id:obj.id,
                   peopleCount:obj.peopleCount,
                   price:obj.price?obj.price/100:0.01
               }
               this.dialogVisible=true;
            },
            updateOcrSchools(){
                let myobj={
                   id:this.myobj.id,
                   peopleCount:this.myobj.peopleCount,
                   price:Math.floor(this.myobj.price*100)
               }
                   updateOcrSchool(myobj).then(res => {
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        this.queryFoodLists();
                        this.dialogVisible=false;
                    }).catch();
            },
            rechargeReminds(id){
               this.$confirm('是否充值提醒?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    rechargeRemind(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '充值提醒成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },    
            //获取列表          
            queryFoodLists() {
                 setTimeout(() => {
                    if(this.locationArray[2]=='0'){
                       this.listQuery.areaCode=this.locationArray[1].slice(0,4)
                    }else{
                       this.listQuery.areaCode=this.locationArray[2]
                    }     
                    this.downLoadHref= global.BasePath+"structure/ocr/downOcrSchool?areaCode="+ 
                    this.listQuery.areaCode +
                    "&searchName=" +
                    this.listQuery.searchName +
                    "&token=" +
                    this.$store.getters.token;         
                    queryOcrSchool(this.listQuery)
                        .then(res => res.data)
                        .then(data => {
                            this.dataList = data.data.dataList;
                            this.total = data.data.pagination.total;
                        }).catch(err => {
                    })
                }, 100);
               
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryFoodLists();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryFoodLists();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryFoodLists();
            },
            //学校
            Identificationmanagementschool(schoolId){
                this.$router.push({
                    path: "Identificationmanagementschool",
                    query:{
                        schoolId:schoolId
                    }
                });
            }, 
            //充值
            Identificationmanagementadd(obj){
                this.$router.push({
                    path: "Identificationmanagementadd",
                     query:{
                        schoolId:obj.schoolId,
                        areaCode:obj.areaCode,
                        price:obj.price,
                        schoolName:obj.schoolName,
                    }
                });
            },
            Identificationmanagementlist(){
                this.$router.push({
                    path: "Identificationmanagementlist"
                });
            },          
        }
    }
</script>
<style lang="scss" scoped>
.shortmessageindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
    .red{
        color:#F56C6C;
    }
    .top-box{
        width: 100%;
        height: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Identificationmanagement/Identificationmanagementindex.vue